<template>
    <ModalComponent
        :name="'borrar-base-email-' + email.id"
        title="¿Seguro que quieres borrar el email?"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Email:</b> {{ email.email }}
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR EMAIL?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="borrarEmail">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['email'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-base-email-' + this.email.id, borrado);
            },
            borrarEmail() {
                this.loading = true;

                const params = {
                    filters : {},
                    email_id: this.email.id,
                    base_id: this.email.lista_abonado_base_comunicado_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.emails.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
